import { useState } from 'react';

export default function ScrambleBox({ scramble, onNew, eventName }) {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(scramble);
      setCopied(true);
      setTimeout(() => setCopied(false), 1200);
    } catch {
      /* 剪贴板不可用时忽略 */
    }
  };

  return (
    <div className="card p-4 sm:p-5">
      <div className="flex items-center justify-between gap-3 mb-3">
        <div className="flex items-center gap-2">
          <span className="text-xs font-semibold text-slate-500 tracking-widest">SCRAMBLE · {eventName}</span>
          <span className="text-[10px] px-1.5 py-0.5 rounded bg-slate-700/60 text-slate-400">打乱公式</span>
        </div>
        <div className="flex gap-2">
          <button onClick={copy} className="text-xs text-slate-400 hover:text-accent px-2 py-1 rounded-lg hover:bg-slate-700/40">
            {copied ? '已复制 ✓' : '复制'}
          </button>
          <button onClick={onNew} className="text-xs text-slate-400 hover:text-accent px-2 py-1 rounded-lg hover:bg-slate-700/40">
            换一个 ↻
          </button>
        </div>
      </div>
      <p className="font-mono text-lg sm:text-xl leading-relaxed text-slate-100 tracking-wide break-words select-all">
        {scramble}
      </p>
    </div>
  );
}
